import React from 'react';
import { Accordion, Badge, Table } from 'react-bootstrap';
import type { SlotEvaluation } from '../utils/teeSlotCapacity';

export type DebugSlotRow = {
    teeSheetId: string;
    teeSheetName: string;
    time: string;
    evaluation: SlotEvaluation;
};

type SuperadminSlotDebugPanelProps = {
    debugSlots: DebugSlotRow[];
    reservationSummary: string;
};

function SuperadminSlotDebugPanel({ debugSlots, reservationSummary }: SuperadminSlotDebugPanelProps) {
    if (!debugSlots.length) {
        return null;
    }

    const availableCount = debugSlots.filter((r) => r.evaluation.available).length;

    return (
        <div className="col-12 mt-3">
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        Superadmin: slot diagnostics ({availableCount} available / {debugSlots.length} total)
                    </Accordion.Header>
                    <Accordion.Body className="p-2">
                        <p className="small text-muted mb-2">{reservationSummary}</p>
                        <div className="table-responsive" style={{ maxHeight: '420px', overflowY: 'auto' }}>
                            <Table size="sm" striped bordered hover className="mb-0 small">
                                <thead className="table-light sticky-top">
                                    <tr>
                                        <th>Tee sheet</th>
                                        <th>Time</th>
                                        <th>On slot</th>
                                        <th>Status</th>
                                        <th>Reason(s)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {debugSlots.map((row) => (
                                        <tr key={`${row.teeSheetId}-${row.time}`}>
                                            <td>{row.teeSheetName}</td>
                                            <td className="text-nowrap">{row.time}</td>
                                            <td className="text-nowrap">
                                                {row.evaluation.occupancyOnStart}/4
                                                {row.evaluation.occupancyOnReround != null &&
                                                    ` · reround ${row.evaluation.occupancyOnReround}/4`}
                                            </td>
                                            <td>
                                                {row.evaluation.available ? (
                                                    <Badge bg="success">AVAILABLE</Badge>
                                                ) : (
                                                    <Badge bg="danger">UNAVAILABLE</Badge>
                                                )}
                                            </td>
                                            <td style={{ fontSize: '0.8rem' }}>
                                                {row.evaluation.available ? (
                                                    <span className="text-muted">—</span>
                                                ) : (
                                                    <ul className="mb-0 ps-3">
                                                        {row.evaluation.reasons.map((reason, i) => (
                                                            <li key={i}>{reason}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
}

export default SuperadminSlotDebugPanel;
